var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallLogo = function SvgSmallLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "bg_logo")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16_TeamAbout",
    transform: "translate(-120.000000, -250.000000)",
    fill: "#4B13E8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hero",
    transform: "translate(120.000000, -158.183867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intro_Text",
    transform: "translate(0.000000, 408.183867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 L32,16.1450823 L15.872,16.1450823 L15.872,32.4203669 L32,32.4203669 L32,48.6956515 L23.936,48.6956515 C10.7165013,48.6956515 0,37.7947697 0,24.3478258 C0,10.9008818 10.7165013,0 23.936,0 L32,0 Z M32,15.3043476 L40,15.3043476 C53.2548267,15.3043476 64,26.205248 64,39.6521734 C64,53.0990988 53.2548267,63.9999992 40,63.9999992 L32,63.9999992 L32,47.7681153 L48.128,47.7681153 L48.128,31.5362315 L32,31.5362315 L32,15.3043476 Z",
    id: "bg_logo"
  })))))));
};
export default SvgSmallLogo;